import {
  GET_USER_REQUESTED,
  GET_USER_SUCCESS,
  GET_USER_FAILURE,
  GET_USER_POLL,
  PATCH_USER_REQUESTED,
  PATCH_USER_SUCCESS,
  PATCH_USER_FAILURE,
  DELETE_USER_REQUESTED,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAILURE,
  CREATE_USERINVITE_REQUESTED,
  CREATE_USERINVITE_SUCCESS,
  CREATE_USERINVITE_FAILURE,
  GET_USERINVITE_REQUESTED,
  GET_USERINVITE_SUCCESS,
  GET_USERINVITE_FAILURE,
  DELETE_USERINVITE_REQUESTED,
  DELETE_USERINVITE_SUCCESS,
  DELETE_USERINVITE_FAILURE,
} from '../actions';

export const initialState = {
  userInviteRoles: [],
  error: null,
  isLoadingUsers: false, // Used for spinner since this call is slower than all others
  isLoading: false,
  invites: [],
  users: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_USER_REQUESTED:
      return {
        ...state,
        isLoadingUsers: true,
        error: null,
      };

    case GET_USER_SUCCESS:
      return {
        ...state,
        isLoadingUsers: false,
        users: action.payload.results,
      };

    case GET_USER_FAILURE:
      return {
        ...state,
        isLoadingUsers: false,
        error: action.payload,
      };

    case GET_USER_POLL:
      return {
        ...state,
      };

    case PATCH_USER_REQUESTED:
      return {
        ...state,
        isLoadingUsers: false, //  Do not show page spinner during patch, use form spinner instead
        error: null,
      };

    case PATCH_USER_SUCCESS: {
      const { users } = state;

      const cachedUsers = users.map((user) => {
        const retUser = { ...user };
        if (user.id === action.meta.userId) {
          if (action.payload.accessDedicated) {
            retUser.orv4id = action.meta.orgORv4ID;
          } else {
            retUser.orv4id = null;
          }
        }
        return retUser;
      });

      return {
        ...state,
        users: cachedUsers,
        isLoadingUsers: false,
      };
    }

    case PATCH_USER_FAILURE:
      return {
        ...state,
        isLoadingUsers: false,
        error: action.payload.response,
      };

    case DELETE_USER_REQUESTED:
      return {
        ...state,
        isLoadingUsers: true,
        error: null,
      };

    case DELETE_USER_SUCCESS:
      return {
        ...state,
        isLoadingUsers: false,
        users: state.users.filter((user) => user.id !== action.meta.userId),
      };

    case DELETE_USER_FAILURE:
      return {
        ...state,
        isLoadingUsers: false,
        error: action.payload,
      };

    case CREATE_USERINVITE_REQUESTED:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case CREATE_USERINVITE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        invites: [action.payload, ...state.invites],
      };

    case CREATE_USERINVITE_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    case GET_USERINVITE_REQUESTED:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case GET_USERINVITE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        invites: action.payload,
      };

    case GET_USERINVITE_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    case DELETE_USERINVITE_REQUESTED:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case DELETE_USERINVITE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        invites: state.invites.filter((invite) => invite.id !== action.meta.inviteId),
      };

    case DELETE_USERINVITE_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
